import { CSVLink } from 'react-csv'
import { BiDownload } from 'react-icons/bi'
import { Grid } from '@mui/material'

const headers = [
  { label: 'Date', key: 'localDate' },
  { label: 'Member Name', key: 'memberName' },
  { label: 'Section Type', key: 'sectionType' },
  { label: 'Section Name', key: 'currentSectionName' },
  { label: 'Movement Type', key: 'movementType' }
]

const DowloadReport = ({ transactions }) => {
  return (
    <Grid size={{ xs: 12 }} className="transaction-item">
      <div className="transaction-button-container">
        <CSVLink
          data={transactions}
          headers={headers}
          filename={'transactions-report.csv'}
          className="transaction-print-button"
        >
          Download
          <BiDownload />
        </CSVLink>
      </div>
    </Grid>
  )
}

export default DowloadReport
